import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h4>{t('footer_about_us_title')}</h4>
              <p>{t('footer_about_us_description')}</p>
              <div className="social-links">
                <a href="https://www.facebook.com/atmasakshifoundation/" aria-label="Facebook"><Facebook size={20} /></a>
                <a href="https://twitter.com/atmasakshifoundation" aria-label="Twitter"><Twitter size={20} /></a>
                <a href="https://www.linkedin.com/in/atmasakshifoundation/" aria-label="LinkedIn"><Linkedin size={20} /></a>
                <a href="https://www.instagram.com/atmasakshifoundation/" aria-label="Instagram"><Instagram size={20} /></a>
              </div>
            </div>

            <div className="footer-column">
              <h4>{t('footer_quick_links_title')}</h4>
              <ul>
                <li><a href="/">{t('home')}</a></li>
                <li><a href="/about">{t('about')}</a></li>
                <li><a href="/donation">{t('donation')}</a></li>
                <li><a href="/events">{t('events')}</a></li>
                <li><a href="/blogs">{t('blog')}</a></li>
                <li><a href="/contact">{t('contact')}</a></li>
              </ul>
            </div>

            {/* <div className="footer-column">
              <h4>Recent Posts</h4>
              <ul>
                <li><a href="#">Give Education, It's The Best Gift Ever</a></li>
                <li><a href="#">Don't treat oceans as universal garbage cans</a></li>
                <li><a href="#">The sun and the sand makes beaches beautiful</a></li>
              </ul>
            </div> */}

            <div className="footer-column">
              <h4>{t('footer_contact_us_title')}</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <MapPin size={18} />
                  <span>{t('footer_address')}</span>
                </div>
                <div className="contact-item">
                  <Mail size={18} />
                  <a href="atmasakshifoundation1@gmail.com">atmasakshifoundation1@gmail.com</a>
                </div>
                <div className="contact-item">
                  <Phone size={18} />
                  <a href="tel:+91-7019914021">+91-7019914021</a>
                  <a href="tel:+91-9448305961">+91-9448305961</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>{t('footer_copyright')}</p>
          <div className="footer-links">
            <Link to="/privacy">{t('footer_privacy_policy')}</Link>
            <Link to="/terms">{t('footer_terms_conditions')}</Link>
            <Link to="/refund">{t('footer_refund_policy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
